import { useSelector } from 'react-redux';

import {
  GetProductsUniversalOptions,
  ProductRequestParams,
} from 'actions/productsDB';
import {
  getOrderProductsByInProductGroup,
  getOrderProductsDirectionInProductGroup,
  getSetting,
} from 'reducers/configs/settings';
import { getSelectedWarehouseID } from 'reducers/warehouses';

import useProducts from './useProducts';

const options: GetProductsUniversalOptions = {
  withMeta: true,
  localFirst: true,
};

const useProductsPerGroup = (
  params: ProductRequestParams & {
    groupID: number;
    pageNo: number;
    recordsOnPage: number;
  },
) => {
  const orderBy = useSelector(getOrderProductsByInProductGroup);
  const orderByDir = useSelector(getOrderProductsDirectionInProductGroup);
  const getItemsFromFirstPriceListOnly = useSelector(
    getSetting('pos_allow_selling_only_from_pricelist1'),
  );
  const warehouseID = useSelector(getSelectedWarehouseID);

  return useProducts(
    {
      ...params,
      orderBy,
      orderByDir,
      includeMatrixVariations: 0,
      getWarehouseSpecificVAT: 1,
      getProductsFor: 'SALES',
      getItemsFromFirstPriceListOnly,
      warehouseID,
    },
    options,
  );
};

export default useProductsPerGroup;
